import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchQuizzes, getQuizParticipants } from "../Quiz/redux/quizSlice";
import AllFeatureDataTable from "../../GuiComponents/AllFeatureDataTable.table";
import { Skeleton } from "@mui/material";

const PracticeQuizzes = () => {
  const dispatch = useDispatch();
  const { quizzes, participants, loading, error } = useSelector(
    (state) => state.quiz
  );

  const [selectedQuiz, setSelectedQuiz] = useState("");

  useEffect(() => {
    dispatch(fetchQuizzes({ type: "2" }));
    setSelectedQuiz("");
  }, [dispatch]);

  const handleQuizChange = (e) => {
    const quizId = e.target.value;
    setSelectedQuiz(quizId);
    if (quizId) {
      dispatch(getQuizParticipants({ quiz_id: quizId }));
    }
  };

  const columns = [
    { Header: "#", accessor: "sno" },
    { Header: "Name", accessor: "username" },
    { Header: "Email", accessor: "email" },
    { Header: "Score", accessor: "score" },
    { Header: "Status", accessor: "participation_status" },
    { Header: "Completed At", accessor: "completed_at" },
  ];

  const data = (participants || []).map((p, index) => ({
    ...p,
    sno: index + 1,
    completed_at: p.completed_at
      ? new Date(p.completed_at).toLocaleString()
      : "-",
  }));

  return (
    <div>
      {loading && <Skeleton count={5} height={30} className="mb-2" />}
      {/* {error && <p className="text-danger">Error: {error}</p>} */}
      {/* issue: `error` can be an object like { error: "..." } (server JSON payload from rejectWithValue), which crashes React: "Objects are not valid as a React child". Coerce to string. */}
      {error && (
        <p className="text-danger">
          Error:{" "}
          {typeof error === "string"
            ? error
            : error?.error || error?.message || "Something went wrong"}
        </p>
      )}

      {!loading && quizzes?.length > 0 && (
        <select
          className="form-select w-50 mb-3 py-1"
          value={selectedQuiz}
          onChange={handleQuizChange}
          style={{ fontSize: "0.9rem" }}
        >
          <option value="">Select Quiz</option>
          {quizzes.map((quiz) => (
            <option key={quiz.id} value={quiz.id}>
              {quiz.title}
            </option>
          ))}
        </select>
      )}

      {selectedQuiz && (
        <div>
          {loading && (
            <div style={{ width: "100%" }}>
              {[...Array(25)].map((_, i) => (
                <Skeleton
                  key={i}
                  variant="rectangular"
                  height={15}
                  className="mb-1"
                />
              ))}
            </div>
          )}
          {!loading && data.length > 0 ? (
            <AllFeatureDataTable columns={columns} data={data} />
          ) : (
            !loading && <p>No participants found for this quiz.</p>
          )}
        </div>
      )}
    </div>
  );
};

export default PracticeQuizzes;
